import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  input
} from "@angular/core";
import { PriceService } from "src/app/services/price.service";
import { PackageResponse, PriceTypeEnum } from "src/domain/client";
import { PricePipe } from "../../../pipes/sharedpipes/price.pipe";
import { PriceDiffPipePipe } from "../../../pipes/price-diff-pipe.pipe";
import { PackagePricePipe } from "../../../pipes/package-price.pipe";
import { FormService } from "src/app/services/form.service";

@Component({
  selector: "app-show-proposal-pps-packages",
  templateUrl: "./show-proposal-pps-packages.component.html",
  imports: [PricePipe, PriceDiffPipePipe, PackagePricePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShowProposalPpsPackagesComponent implements OnInit {
  packages = input.required<PackageResponse[]>();
  public PriceTypeEnum: typeof PriceTypeEnum = PriceTypeEnum;

  constructor(
    public priceService: PriceService,
    public formService: FormService
  ) {}

  ngOnInit(): void {}
}
